import { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { saveTest } from "../utils/firebase";

export const useDailyTest = () => {
  const id = uuidv4();
  const startedAt = new Date();
  const [testData, setTestData] = useState({
    id,
    startedAt,
  });
  const [allowStorage, setAllowStorage] = useState(true);

  useEffect(() => {
    if (allowStorage) saveTest(testData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testData]);

  const addTestDataForKey = (key, data) => {
    setTestData((oldData) => {
      const newTestData = { ...oldData };
      newTestData[key] = data;
      return newTestData;
    });
  };

  return {
    addTestDataForKey,
    testData,
    allowStorage,
    setAllowStorage,
  };
};
